"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwordPlungeAbilityHandler = exports.SwordPlungeActorAbilityFactory = exports.SwordPlungeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/effects/core");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Duration_1 = require("../../core/Duration");
class SwordPlungeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SwordPlunge;
        this.__typeName = "SwordPlunge";
    }
}
exports.SwordPlungeAbilityArgs = SwordPlungeAbilityArgs;
let SwordPlungeActorAbilityFactory = class SwordPlungeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SwordPlunge", "OneEnemies", 0);
    }
};
SwordPlungeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SwordPlunge")
], SwordPlungeActorAbilityFactory);
exports.SwordPlungeActorAbilityFactory = SwordPlungeActorAbilityFactory;
let SwordPlungeAbilityHandler = class SwordPlungeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: "SwordPlunge",
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Frost", 80)
            ],
            onHit: sequence => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVicinityLocationSelector(targetId, "front", "bottom"), "IceRupture"));
                container.applyDebuff({
                    sequence: sequence.pushSequence("sequential"),
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(3),
                    effect: new core_1.SlowEffectArgs(1)
                });
            }
        });
    }
};
SwordPlungeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SwordPlunge)
], SwordPlungeAbilityHandler);
exports.SwordPlungeAbilityHandler = SwordPlungeAbilityHandler;
